import { render, staticRenderFns } from "./EditingDFGuideText2.vue?vue&type=template&id=7bb1ed5a&"
import script from "./EditingDFGuideText2.vue?vue&type=script&lang=js&"
export * from "./EditingDFGuideText2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports